export type MessagePresentation = {
  alignment: 'flex-start' | 'center' | 'flex-end';
  textAlignment: 'left' | 'center' | 'right';
  attribution: 'client' | 'agency' | 'unknown';
};

export const getMessagePresentation = (inbound: boolean | null): MessagePresentation => {
  if (inbound === true) {
    return {
      alignment: 'flex-start',
      textAlignment: 'left',
      attribution: 'client',
    };
  }

  if (inbound === false) {
    return {
      alignment: 'flex-end',
      textAlignment: 'right',
      attribution: 'agency',
    };
  }

  return {
    alignment: 'center',
    textAlignment: 'center',
    attribution: 'unknown',
  };
};
